import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";
import { ClientPortalWebNarrativeModel } from "services/api/cplapi/CPLAPI";
import { IClientPortalWebNarrativesService } from "services/ClientPortalWebNarrativesService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { RootState } from "setup/redux/RootReducer";

type DashboardIntroductionMessageState = {
  Loading: boolean;
  IntroductionMessage: ClientPortalWebNarrativeModel;
};

const initialState: DashboardIntroductionMessageState = {
  Loading: false,
  IntroductionMessage: new ClientPortalWebNarrativeModel(),
};

export const introductoryMessageSlice = createSlice({
  name: "IntroductoryMessage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardIntroductionMessage.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getDashboardIntroductionMessage.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getDashboardIntroductionMessage.fulfilled, (state, action) => {
        state.IntroductionMessage = action.payload;
        state.Loading = false;
      });
  },
});

export const getDashboardIntroductionMessage = createAsyncThunk(
  "IntroductoryMessage/GetDashboardIntroductionMessage",
  async () => {
    const webNarrativesService = container.get<IClientPortalWebNarrativesService>(
      SERVICE_TYPES.ClientPortalWebNarrativesService
    );
    return await webNarrativesService.getClientPortalWebNarrative(ClientPortalWebNarratives.DashboardIntro);
  }
);

export const selectLoading = (state: RootState) => state.dashboardIntroductionMessage.Loading;
export const selectIntroductionMessage = (state: RootState) => state.dashboardIntroductionMessage.IntroductionMessage;

export default introductoryMessageSlice.reducer;
